import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchQuizLeaderboard } from "../services/quizLeaderboardService";

function normalizeState(item = {}, index = 0) {
  return {
    id: Number(item?.state_id || index),
    name: item?.full_name || item?.state_name || "State",
  };
}

function normalizePlayer(item = {}, index = 0) {
  return {
    rank: Number(item?.rank || index + 1),
    studentId: Number(item?.student_id || 0),
    name: item?.name || "Student",
    avatar: item?.profile_pics || "",
    score: Number(item?.score || 0),
    totalQuestionsAttempted: Number(item?.total_questions_attempted || 0),
    totalTime: Number(item?.total_time || 0),
    isUser: Number(item?.is_user || 0) === 1,
    assesmentBatchId: Number(item?.assesment_batch_id || 0),
    batchDate: item?.batch_date || "",
  };
}

function normalizePagination(payload = {}) {
  const pagination = payload?.pagination || {};

  return {
    currentPage: Number(pagination?.currentPage || pagination?.current_page || 1),
    totalPages: Number(pagination?.totalPages || pagination?.total_pages || 1),
    totalRecords: Number(pagination?.totalRecords || pagination?.total_records || 0),
  };
}

export function useQuizLeaderboard(params = {}, options = {}) {
  return useInfiniteQuery({
    queryKey: ["quizLeaderboard", params],
    queryFn: async ({ pageParam = 1 }) => {
      const { payload } = await fetchQuizLeaderboard({
        ...params,
        page: pageParam,
      });
      const pagination = normalizePagination(payload);

      return {
        quizName: payload?.quiz_name || "",
        batchDate: payload?.batch_date || "",
        stateName: payload?.state_name || "",
        states: (Array.isArray(payload?.states) ? payload.states : []).map(normalizeState),
        topThree: (Array.isArray(payload?.top_three) ? payload.top_three : []).map(normalizePlayer),
        players: (Array.isArray(payload?.all_students) ? payload.all_students : []).map(normalizePlayer),
        currentStudent: payload?.current_student ? normalizePlayer(payload.current_student) : null,
        pagination,
      };
    },
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.pagination.currentPage + 1;
      return nextPage <= lastPage.pagination.totalPages ? nextPage : undefined;
    },
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    initialPageParam: 1,
  });
}
